import Box from 'ReusableComponents/Box';
import React from 'react';
import styled from 'styled-components';
import { DESIGN_CONFIG } from 'utils';

const StyledInput = styled.input`
  background: ${DESIGN_CONFIG.color.neutral.neutral500};
  border: 1px solid ${DESIGN_CONFIG.color.neutral.neutral200};
  border-radius: 6px;
  font-size: ${DESIGN_CONFIG.typography.common.webLabel.fontSize};
  font-weight: ${DESIGN_CONFIG.typography.common.webLabel.fontWeight};
  height: 3rem;
  outline: none;
  padding: 0.875rem 1rem;
  transition: all 0.4s ease;
  width: 100%;
  transition: all 0.2s ease-in;
  &:hover,
  &:focus-visible,
  &:focus {
    border: 1px solid ${DESIGN_CONFIG.color.primary.primaryMain};
  }
  &::placeholder {
    color: ${DESIGN_CONFIG.color.text.text200};
    font-size: ${DESIGN_CONFIG.typography.common.webLabel.fontSize};
  }
`;
function SignUpInput({ field, meta, type, id, placeHolder }) {
  return (
    <Box>
      <StyledInput {...field} id={id} placeholder={placeHolder} type={type} />
      {meta.touched && meta.error ? (
        <div
          aria-live='assertive'
          role='alert'
          style={{
            color: `${DESIGN_CONFIG.color.error.errorMain}`,
            fontSize: `${DESIGN_CONFIG.typography.common.webLabel.fontSize}`,
            fontWeight: `${DESIGN_CONFIG.typography.common.webLabel.fontWeight}`,
            margin: '2px 0 0 4px',
          }}
        >
          {meta.error}
        </div>
      ) : null}
    </Box>
  );
}

export default SignUpInput;
